module.exports = __webpack_public_path__ + "static/NeuzeitGro-Bla-225250a6c69c48f9df3d6da4b45cd3a1.woff";